import React from 'react'
import ErrorIcon from '@material-ui/icons/Error'
import { Drawer } from '@material-ui/core'
import { ErrorItem } from './ErrorsIndicator'

type Props = {
  errors: ErrorItem[]
  drawerTitle?: string
  drawerDescription?: string
  isOpen: boolean
  onClose: () => void
  actionButton?: React.ReactNode
}

export const ErrorsDrawer = ({ errors, isOpen, onClose, ...props }: Props) => (
  <Drawer open={isOpen} onClose={onClose}>
    {/* Capped rather than sized to content: a long campaign name in the title would otherwise
        widen the drawer until each error's message and button sat off-screen. */}
    <div className="w-screen max-w-5xl">
      <div style={{ display: 'flex', borderBottom: '1px solid grey', padding: '20px 30px' }}>
        <ErrorIcon
          style={{
            height: '60px',
            width: '60px',
            color: 'maroon',
            marginRight: '5px',
            flexShrink: 0,
          }}
        />
        <div className="min-w-0">
          <p
            className="break-words"
            style={{ margin: 0, paddingBottom: '2px', color: 'black', fontSize: '22px' }}
          >
            {props.drawerTitle || 'Errors were found'}
          </p>
          <p style={{ margin: 0, padding: 0, color: 'darkgrey', fontSize: '14px' }}>
            {props.drawerDescription ||
              'Facebook rejected this item for the reasons shown below.  please take corrective actions.'}
          </p>
        </div>
      </div>
      <div className="divide-y gap-5">
        {errors.map((error, i) => (
          <div className="p-4 flex space-x-8" key={i}>
            <p className="text-red-500 font-medium text-md w-1/3 flex-shrink-0 break-words">
              {error?.title || 'Error'}
            </p>
            <div className="flex-1 min-w-0">
              <p className="font-medium">{error.message}</p>
              {error?.details && <p className="text-xs text-gray-800 pt-1">{error?.details}</p>}
              {/* Every action opens what fixes the error, which belongs on top rather than behind
                  this drawer. */}
              <div className="mt-2" onClick={onClose}>
                {error.actionButton && error.actionButton}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </Drawer>
)
